export const checkIsPartTwo = (data) =>
    Object.values(data)
        .flat()
        .map(({ value }) => value)
        .reduce((a, b) => a + b, 0);
